export default defineNuxtRouteMiddleware(() => {
  const { setBreadcrumbs } = useBreadcrumbs();
  setBreadcrumbs([
    {
      text: 'ダイエットQ&A',
    },
  ]);
});
